<form class="" [formGroup]="MDAppoinmentForm">
  <div class="row g-3 mb-3">
    <div class="col-md-6">
      <div class="form-floating my-2" id="nextMdDiv">
        <input type="date" class="form-control" id="nextMDAppt" formControlName="nextMDAppt" placeholder="Next MD Appointment" [min]="!isData ? minCurrDate : null" />
        <label for="nextMdAppointment">Next MD Appointment</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating my-2" id="nextRomDiv">
        <input type="date" class="form-control" id="nextROMAppt" formControlName="nextROMAppt" placeholder="Next MD Appointment" />
        <label for="nextRomAppointment">Next ROM Appointment</label>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="mdprn" formControlName="mdprn" />
        <label class="form-check-label" for="mdPrn"> MD PRN </label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="noROM" formControlName="noROM" />
        <label class="form-check-label" for="noRom"> No ROM </label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-floating my-2">
        <input type="date" class="form-control" id="internist" formControlName="internist" placeholder="internist" />
        <label for="initial">Internist</label>
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-md-4" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]">
      <div class="form-floating">
        <input type="date" class="form-control" id="internistFU{{ item }}" formControlName="internistFU{{ item }}" placeholder="Internist FU{{ item }}" />
        <label for="internistFU{{ item }}">Internist FU{{ item }} | for</label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row g-3 mb-3">
    <div class="col-md-4">
      <div class="form-floating">
        <input type="date" class="form-control" id="rom" formControlName="rom" placeholder="rom" />
        <label for="rom">ROM 1</label>
      </div>
    </div>
    <div class="col-md-4" *ngFor="let item of [2, 3, 4, 5]">
      <div class="form-floating">
        <input type="date" class="form-control" id="roM{{ item }}" formControlName="roM{{ item }}" placeholder="ROM {{ item }}" />
        <label for="rom{{ item }}">ROM {{ item }}</label>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
  <button type="button" class="btn btn-primary" (click)="isData ? updateMDAppointment() : makeMDAppoinment()" [disabled]="patientData.isDischarged">
    {{ isData ? 'Update' : 'Create' }} Appointment
  </button>
</div>
